import i18next from '~/utils/i18n';

const notification = () => ({
    CREATE_FOLDER_SUCCESS: i18next.t('WordBooks.create_folder_success'),
    EDIT_FOLDER_SUCCESS: i18next.t('WordBooks.edit_folder_success'),
    DELETE_FOLDER_SUCCESS: i18next.t('WordBooks.delete_folder_success'),
});

export default notification;
